var render, staticRenderFns
import script from "./ResizeTable.vue?vue&type=script&lang=js"
export * from "./ResizeTable.vue?vue&type=script&lang=js"
import style0 from "./ResizeTable.vue?vue&type=style&index=0&id=5e281e93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports